import D2C_ServiceData from './Data'

class D2C_ServiceEtcd extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = false
  static typeName = 'etcd'
  static typeTitle = 'Etcd'
  static color = '#0099dd'
  static fields = {
    ...D2C_ServiceData.fields,
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        default: ['node'],
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'etcd',
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 4001},
      ],
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: 'latest',
      enum: ['latest'],
    },
  }
}

export default D2C_ServiceEtcd
